import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  Link,
} from "@material-ui/core";
import { toast } from "react-toastify";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";

import useStyles from "../../../themes/style.js";
import { useNotification } from "../../../hooks/useNotification.js";
import { IoClose } from "react-icons/io5";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import NoDataFound from "../../../components/NoDataFound/index.js";

export default function MyConcern() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();

  const token = localStorage.getItem("token");
  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const [loader, setLoader] = useState(false);
  const [concernData, setConcernData] = useState([]);
  const [concernViewData, setConcernViewData] = useState({
    title: "",
    description: "",
    createdAt: "",
    reply: "",
  });
  const [concernModalOpen, setConcernModalOpen] = useState(false);
  const [concernViewOpen, setConcernViewOpen] = useState(false);

  const handleFeedbackViewOpen = (item) => {
    setConcernViewOpen(true);
    setConcernViewData({ ...item });
  };

  const handleFeedbackViewClose = () => {
    setConcernViewOpen(false);
  };

  const handleConcernModalOpen = () => {
    setConcernModalOpen(true);
    reset();
  };

  const handleConcernModalClose = () => {
    setConcernModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    fetchConcernData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchConcernData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}opinions/viewMyConcerns`,
        data: {
          page: currerntPage,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setConcernData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}opinions/viewMyConcerns`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setConcernData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  async function handleAdd(values) {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}opinions/addConcern`,
        {
          title: values.title,
          description: values.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchConcernData();
        handleConcernModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          {/* <PageTitle title="My Concern" /> */}
        </Grid>
        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={handleConcernModalOpen}
            >
              Add Concern
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              color="primary"
              onClick={handleConcernModalOpen}
            >
              Add
            </Button>
          </div>
        </Grid>
      </Grid>

      {concernData.length <= 0 && (
         <NoDataFound height="80vh" message="No Data Found" />
      )}

      <Grid container spacing={2}>
        {concernData.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item}>
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  {item.title}
                </Typography>
                {item.isReplied && (
                  <Typography color="textSuccess" gutterBottom>
                    <Tooltip
                      title="Replied"
                      placement="bottom"
                      aria-label="download"
                    >
                      <span>
                        <IoCheckmarkDoneOutline color="green" size={20} />
                      </span>
                    </Tooltip>
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  component="p"
                  style={{
                    minHeight: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 6,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {item.description}
                </Typography>
              </CardContent>
              <CardActions
                style={{
                  padding: "0px 16px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    handleFeedbackViewOpen(item);
                  }}
                >
                  Learn More
                </Link>
                <Typography
                  variant="body2"
                  component="p"
                  style={{ fontSize: "12px", color: "#515151" }}
                >
                  {moment(new Date(item.createdAt)).format("Do MMM YY")}
                </Typography>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        open={concernViewOpen}
        fullWidth
        maxWidth="xs"
        onClose={handleFeedbackViewClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ padding: "20px 30px" }}>
          <Box style={{ display: "flex", justifyContent: "end" }}>
            <div
              onClick={handleFeedbackViewClose}
              style={{ cursor: "pointer" }}
            >
              <IoClose size={22} />
            </div>
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3>
              {moment(new Date(concernViewData.createdAt)).format("Do MMM YY")}
            </h3>
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#ccc",
              }}
            ></div>
          </div>

          <h2 color="textPrimary" style={{ marginTop: 0 }}>
            {concernViewData.title}
          </h2>
          <Typography variant="body1" component="p">
            {concernViewData.description}
          </Typography>
          {concernViewData.isReplied && (
            <>
              <h3>Reply from Admin</h3>

              <Typography variant="body1" component="p">
                {concernViewData.reply}
              </Typography>
            </>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={concernModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={handleConcernModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", margin: 0 }}>My Concern</h3>
          {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="title">
                  Subject
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    placeholder="Enter Subject"
                    name="title"
                    {...register("title")}
                    error={errors.title ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.title?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="description">
                  Message
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    multiline
                    minRows={8}
                    size="small"
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    placeholder="Enter your thoughts here..."
                    name="description"
                    {...register("description")}
                    error={errors.description ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.description?.message}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleConcernModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
